/**
 * Vue 3 自定义指令 Composable
 * 提供在组件中按需使用指令的方式
 */
import motion from '@/compositions/directives/motion'

/**
 * 使用自定义指令的组合式函数
 * @returns {Object} 所有自定义指令
 *
 * @example
 * // 在组件中局部注册指令
 * <script setup>
 * import { useDirectives } from '@/composables/useDirectives'
 *
 * const directives = useDirectives()
 * </script>
 *
 * <template>
 *   <div v-motion:targetId="isActive">Click me</div>
 * </template>
 */
export function useDirectives() {
  return {
    motion
  }
}

// 单独导出指令,便于按需引入
export { motion }

// 如果需要在组件中局部注册指令
export default {
  motion
}
